import { useState } from 'react';
// const API_URL = "http://localhost:3000/api/create-user"

const modules = [
  { id: 1, name: "User Management", permissions: [] },
  { id: 2, name: "Service Module", permissions: [] },
  { id: 3, name: "Prompt Module", permissions: [] },
];

const roles = [
  { id: 1, role: "Owner" },
  { id: 2, role: "DealershipAdmin" },
  { id: 3, role: "User" }
];

const Createuser = () => {
  // const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState("")
  const [role, setRole] = useState(roles[0].role);
  const [modulePermissions, setModulePermissions] = useState(modules);

  const handlePermissionChange = (id, permissionType) => {
    setModulePermissions((prevpermissions) => {
      return prevpermissions.map((module) => {
        if (module.id === id) {
          const hasPermission = module?.permissions?.includes(permissionType);
          if (hasPermission) {
            return {
              ...module,
              permissions: module.permissions.filter((perm) => perm !== permissionType)
            }
          }
          else {
            return {
              ...module,
              permissions: [...module.permissions, permissionType]
            }
          }
        } else {
          return module
        }
      })
    })
  };
  console.log(modulePermissions)

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    setError("") //clear prev errors

    const payload = {
      email,
      password,
      role,
      assignedModules: modulePermissions.map(({ name, permissions }) => ({
        name,
        permissions,
      })),
    };

    // try {
    //   // Make POST request to API_URL
    //   const response = await fetch(API_URL, {
    //     method: "POST",
    //     headers: {
    //       "Content-Type": "application/json",
    //     },
    //     body: JSON.stringify(payload),
    //   });

    //   if (!response.ok) {
    //     const errorData = await response.json(); // Attempt to parse error message from response
    //     throw new Error(errorData.message || `Request failed with status ${response.status}`);
    //   }
    //   const jsonRes = await response.json();
    //   console.log("User created successfully:", jsonRes);

    //   // Optionally reset the form
    //   setEmail("");
    //   setPassword("");
    //   setRole(roles[0].role);
    //   setModulePermissions(modules);
    //   alert("User created successfully!");
    //   setIsLoading(false)
    // } catch (error) {
    //   console.error("Error creating user:", error.message);
    //   setError(error.message || "An unexpected error occurred");
    //   setIsLoading(false)
    // } finally {
    //   setIsLoading(false);
    // }
    console.log('Form submitted:', payload);
  };





  return (
    <div className="max-w-md mx-auto mt-10 p-6 bg-white rounded-lg shadow-md">
      <h2 className="text-2xl font-bold mb-6 text-center text-gray-800">Create User</h2>
      {error && <div>{error}</div>}
      <form onSubmit={handleSubmit} className="space-y-4">
        {/* <div>
          <label htmlFor="name" className="block text-sm font-medium text-gray-700">Name</label>
          <input
            type="text"
            id="name"
            name="name"
            required
            className="mt-1 block w-full px-3 py-2 bg-white border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500"
            placeholder="Enter name"
            value={name}
            onChange={(e) => setName(e.target.value)}
          />
        </div> */}
        <div>
          <label htmlFor="email" className="block text-sm font-medium text-gray-700">Email</label>
          <input
            type="email"
            id="email"
            name="email"
            required
            className="mt-1 block w-full px-3 py-2 bg-white border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500"
            placeholder="Enter email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />
        </div>
        <div>
          <label htmlFor="password" className="block text-sm font-medium text-gray-700">Password</label>
          <input
            type="password"
            id="password"
            name="password"
            required
            className="mt-1 block w-full px-3 py-2 bg-white border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500"
            placeholder="Enter password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          />
        </div>
        {/* <div>
          <label htmlFor="role" className="block text-sm font-medium text-gray-700">
            Role
          </label>
          <select
            id="role"
            name="role"
            value={role}
            onChange={(e) => setRole(e.target.value)}
            className="mt-1 block w-full px-3 py-2 bg-white border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500"
          >
            {roles?.map(({ id, role }) => (
              <option key={id} value={role}>
                {role}
              </option>
            ))}
          </select>
        </div> */}
        <div>
          <label className="block text-sm font-medium text-gray-700">Module Permissions</label>
          <div className="mt-2 space-y-2">
            {modulePermissions.map(({ id, name, permissions }) => (
              <div key={id} className="flex items-center justify-between">
                <span className="text-gray-700">{name}</span>
                <div className="flex items-center space-x-4">
                  <label className="flex items-center space-x-2">
                    <input
                      type="checkbox"
                      checked={permissions?.includes("read")}
                      onChange={() => handlePermissionChange(id, "read")}
                      className="h-4 w-4 text-indigo-600 border-gray-300 rounded focus:ring-indigo-500"
                    />
                    <span className="text-sm text-gray-700">Read</span>
                  </label>
                  <label className="flex items-center space-x-2">
                    <input
                      type="checkbox"
                      checked={permissions?.includes("write")}
                      onChange={() => handlePermissionChange(id, 'write')}
                      className="h-4 w-4 text-indigo-600 border-gray-300 rounded focus:ring-indigo-500"
                    />
                    <span className="text-sm text-gray-700">Write</span>
                  </label>
                </div>
              </div>
            ))}
          </div>
        </div>
        <button
          type="submit"
          // disabled={isLoading}
          className="w-full flex justify-center py-2 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 disabled:opacity-50 disabled:cursor-not-allowed"
        >
          {isLoading ? "Creatinguser" : "Createuser"}
        </button>
      </form>
    </div>
  );
};

export default Createuser;
